import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

/**
 * Фильтры вкладки «Отчет по АВР чекам».
 *
 * Статусы соответствуют жизненному циклу чека в ptc-fiscal-service:
 * приём и обе стадии обработки (начисление, фискализация) для оператора неразличимы
 * и схлопнуты в «В обработке» — по ним всё равно нельзя предпринять никакого действия.
 * «Не подлежит фискализации» (SKIPPED) показываем отдельно: такие АВР чек не получат никогда,
 * и без отдельного статуса они выглядели бы как вечно висящие в обработке.
 */
const CHECK_STATUSES = [
    { id: "SUCCESS", name: "Успешно" },
    { id: "FAILED", name: "Ошибка" },
    { id: "IN_PROGRESS", name: "В обработке" },
    { id: "SKIPPED", name: "Не подлежит фискализации" },
];

const AvrCheckFilter = ({ filterParam, setFilterParam, onSubmit, onClear }) => {
    return (
        <form onSubmit={onSubmit}>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="slqNum">Номер SLQ</label>
                    <InputText
                        id="slqNum"
                        name="slqNum"
                        placeholder="Введите номер SLQ"
                        value={filterParam.slqNum || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, slqNum: e.target.value })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="checkNumber">ID чека</label>
                    <InputText
                        id="checkNumber"
                        name="checkNumber"
                        placeholder="Введите ID чека"
                        value={filterParam.checkNumber || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, checkNumber: e.target.value })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="fio">ФИО</label>
                    <InputText
                        id="fio"
                        name="fio"
                        placeholder="Введите ФИО"
                        value={filterParam.fio || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, fio: e.target.value })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="iin">ИИН</label>
                    <InputText
                        id="iin"
                        name="iin"
                        placeholder="Введите ИИН"
                        keyfilter="pint"
                        maxLength={12}
                        value={filterParam.iin || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, iin: e.target.value })}
                    />
                </div>
            </div>

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="signedFrom">Дата и время подписания АВР, с</label>
                    <Calendar
                        id="signedFrom"
                        name="signedFrom"
                        value={filterParam.signedFrom}
                        onChange={(e) => setFilterParam({ ...filterParam, signedFrom: e.value })}
                        locale="ru"
                        showTime
                        showIcon
                        showButtonBar
                        placeholder="Выберите дату и время"
                        onClearButtonClick={() => setFilterParam({ ...filterParam, signedFrom: null })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="signedTo">Дата и время подписания АВР, по</label>
                    <Calendar
                        id="signedTo"
                        name="signedTo"
                        value={filterParam.signedTo}
                        onChange={(e) => setFilterParam({ ...filterParam, signedTo: e.value })}
                        locale="ru"
                        showTime
                        showIcon
                        showButtonBar
                        placeholder="Выберите дату и время"
                        onClearButtonClick={() => setFilterParam({ ...filterParam, signedTo: null })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="status">Статус чека</label>
                    <Dropdown
                        id="status"
                        name="status"
                        value={filterParam.status}
                        options={CHECK_STATUSES}
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Выберите статус"
                        showClear
                        onChange={(e) => setFilterParam({ ...filterParam, status: e.value })}
                    />
                </div>
            </div>

            <div className="p-grid p-justify-end">
                <div className="p-mr-2">
                    <Button type="submit" label="Найти" />
                </div>
                <div className="p-mr-2">
                    <Button className="p-button-warning" label="Сбросить" onClick={onClear} />
                </div>
            </div>
        </form>
    );
};

AvrCheckFilter.propTypes = {
    filterParam: PropTypes.object.isRequired,
    setFilterParam: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};

export { CHECK_STATUSES };
export default AvrCheckFilter;
